import { DeliveryCheckContextProvider } from '@euler/app/flows/task/functions/task-detail/delivery-check/DeliveryCheckContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { DeliveryCheckSceneType } from '@euler/model/enum';
import { WiredDeliveryCheckScreenContent } from './components/WiredDeliveryCheckScreenContent';
import { WiredDeliveryCheckScreenContentForIpad } from './components/WiredDeliveryCheckScreenContent.iPad';

export const SamplingCheckScreen = wrapNavigatorScreen(
  () => {
    const isMobile = useIsMobileLayout();
    if (isMobile) {
      return (
        <DeliveryCheckContextProvider
          sceneType={DeliveryCheckSceneType.SamplingCheck}
        >
          <WiredDeliveryCheckScreenContent />
        </DeliveryCheckContextProvider>
      );
    }
    return (
      <DeliveryCheckContextProvider
        sceneType={DeliveryCheckSceneType.SamplingCheck}
      >
        <WiredDeliveryCheckScreenContentForIpad />
      </DeliveryCheckContextProvider>
    );
  },
  { headerShown: false },
);
